import type {
	AlertInfoRequestModel,
	AlertModel,
	AlertsInfoResponseModel,
	MultipleAlertInfoRequestModel,
	MultipleAlertsInfoResponseModel,
} from '@/shared/generated'
import type { UseQueryOptions } from '@/shared/lib/query-client'

import { useQuery } from '@tanstack/react-query'

import { client } from '@/shared/api/client'

export const pricingAlertsQueries = {
	list: (params: AlertInfoRequestModel) => ({
		queryKey: ['pricing-alerts', params],
		queryFn: () => client.bi.getAlertsInfo(params),
	}),
	multiple: (params: MultipleAlertInfoRequestModel) => ({
		queryKey: ['multiple-pricing-alerts', params],
		queryFn: () => client.bi.getMultipleAlertsInfo(params),
	}),
	annotations: () => ({
		queryKey: ['pricing-alerts-annotations'],
		queryFn: () => client.products.getAlerts(),
	}),
}
export function useMultiplePricingAlertsQuery<
	T = MultipleAlertsInfoResponseModel,
>(
	params: MultipleAlertInfoRequestModel,
	options?: UseQueryOptions<MultipleAlertsInfoResponseModel, Error, T>
) {
	return useQuery<MultipleAlertsInfoResponseModel, Error, T>({
		...pricingAlertsQueries.multiple(params),
		...(options || {}),
	})
}

export function usePricingAlertsQuery<T = AlertsInfoResponseModel>(
	params: AlertInfoRequestModel,
	options?: UseQueryOptions<AlertsInfoResponseModel, Error, T>
) {
	return useQuery<AlertsInfoResponseModel, Error, T>({
		...pricingAlertsQueries.list(params),
		...(options || {}),
	})
}
export function usePricingAlertsAnnotationsQuery<T = AlertModel[]>(
	options?: UseQueryOptions<AlertModel[], Error, T>
) {
	return useQuery<AlertModel[], Error, T>({
		...pricingAlertsQueries.annotations(),
		...(options || {}),
	})
}
